<template>
	<div>
		<v-data-table
			:headers="headers"
			:items="list"
			:loading="loadTable"
			hide-default-footer
			class="elevation-4"
			:items-per-page="-1"
			loading-text="Данные подгружаются..."
		>
			<template v-slot:top>
				<v-toolbar flat>
					<v-btn color="#4854FE" @click="dialogGroup = true" outlined dark>+ Добавить группу</v-btn>
				</v-toolbar>
			</template>

			<template v-slot:item="{item, index}">
				<tr>
					<td>
						<v-btn @click="item.isOpen = !item.isOpen" small icon>
							<v-icon>
								{{ item.isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
							</v-icon>
						</v-btn>
						<span>{{ item.groupName }}</span>
					</td>
					<td style="text-align: end;">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon @click="addIndicator(item.groupId)" v-bind="attrs" v-on="on">mdi-plus-circle</v-icon>
							</template>
							<span>Добавить</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon @click="editeGroup(item)" v-bind="attrs" v-on="on">mdi-pencil-box-outline</v-icon>
							</template>
							<span>Редактировать</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon @click="index !== list.length-1 ? changeIndex1level(list, index, index+1, item.groupId, false) : ''" v-bind="attrs" v-on="on">mdi-arrow-down-circle-outline</v-icon>
							</template>
							<span>Переместить вниз</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon @click="index !== 0 ? changeIndex1level(list, index, index-1, item.groupId, true) : ''" v-bind="attrs" v-on="on">mdi-arrow-up-circle-outline</v-icon>
							</template>
							<span>Переместить вверх</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon @click="deleteGroup(item.groupId, index)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
							</template>
							<span>Удалить</span>
						</v-tooltip>
					</td>
				</tr>

				<tr v-if="item.isOpen">
					<td colspan="2">
						<table style="width: 100%" class="elevation-2">
							<tbody>
								<tr v-for="(it, key) in item.indicators" :key="'R'+key" class="border-bottom: 1px gray solid">
									<td class="td-is-open">{{ it.indicatorName }}</td>
									<td class="td-is-open pr-0 mr-0" style="text-align: end;">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon @click="editeIndicator(it, item.groupId)" v-bind="attrs" v-on="on">mdi-pencil-box-outline</v-icon>
											</template>
											<span>Редактировать</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon @click="key !== item.indicators.length-1 ? changeIndex2level(idSystems, item.groupId, it.indicatorName, item.indicators, key, key+1, false) : ''" v-bind="attrs" v-on="on">mdi-arrow-down-circle-outline</v-icon>
											</template>
											<span>Переместить вниз</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon @click="key !== 0 ? changeIndex2level(idSystems, item.groupId, it.indicatorName, item.indicators, key, key-1, true) : ''" v-bind="attrs" v-on="on">mdi-arrow-up-circle-outline</v-icon>
											</template>
											<span>Переместить вверх</span>
										</v-tooltip>
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon @click="deleteIndicator(it.indicatorName, idSystems, item.groupId, item.indicators, key)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
											</template>
											<span>Удалить</span>
										</v-tooltip>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</template>
		</v-data-table>


		<!-- Добавить/Редактировать показатель -->
		<v-dialog v-model="dialogIndicator" max-width="1400px" persistent>
			<v-card>
				<v-toolbar dark color="#001e46">
					<v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
						{{ editeIndicatorFlag ? 'Редактировать' : 'Добавить' }} показатель
					</v-toolbar-title>

					<v-spacer></v-spacer>

					<v-toolbar-items>
						<v-btn icon color="rgba(129, 182, 228, 0.95)" @click="closeIndicator">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-card-text>
					<v-container fluid>
						<v-form ref="form" v-model="validIndicator" lazy-validation>
							<v-row>
								<v-col cols="12" sm="12" md="12" class="mt-5">
									<v-text-field :rules="[rules.required]" outlined dense hide-details v-model="objIndicator.indicatorName" label="Наименование показателя" />
								</v-col>
								<v-col cols="12" sm="12" md="12">
									<v-select :rules="[rules.required]" outlined dense hide-details item-text="name" item-value="id" :items="listGroup" v-model="objIndicator.groupId" label="Группа" />
								</v-col>

								<v-col cols="12" sm="12" md="12">

									<v-btn class="pl-0 pr-0 mb-2" color="#4854FE" text outlined dark @click="addRow(objIndicator.propertyDataList)">
										<v-icon>mdi-plus-circle</v-icon>
										Добавить возраст
									</v-btn>

									<v-row v-for="(item, key) in objIndicator.propertyDataList" :key="'A'+key">
										<v-col cols="2" sm="2" md="2" align-self="start">
											<v-text-field type="number" :rules="[rules.required]" outlined dense hide-details v-model="item.ageOnMonth" label="Возраст(мес)" />
										</v-col>
										<v-col class="mt-1" cols="5" sm="5" :md="newIndicator ? 'auto' : 5" align-self="start">
											<v-radio-group dense hide-details v-model="item.valueType" row>
												<v-radio label="Диапазон" :value="1" />
												<v-radio label="Значение" :value="2" />
												<v-radio v-if="!newIndicator" label="Справочник" :value="3" />
											</v-radio-group>
										</v-col>
										<v-col cols="5" sm="5" :md="newIndicator ? 7 : 5">
											<!-- Диапазон -->
											<v-row v-if="item.valueType == 1">
												<v-col cols="3" sm="3" :md="activeInputAnalyzer ? 2 : 3">
													<v-text-field type="number" :rules="[rules.required, item.minValue && item.maxValue ? rules.rangeFromTo(+item.minValue, +item.maxValue) : true]" outlined dense hide-details v-model="item.minValue" label="От" />
												</v-col>
												<v-col cols="3" sm="3" :md="activeInputAnalyzer ? 2 : 3">
													<v-text-field type="number" :rules="[rules.required, item.minValue && item.maxValue ? rules.rangeFromTo(+item.minValue, +item.maxValue) : true]" outlined dense hide-details v-model="item.maxValue" label="До" />
												</v-col>
												<v-col
                                                    :cols="key === 0 ? (activeInputAnalyzer ? 4: 5) : (activeInputAnalyzer ? 3: 5)"
                                                    :sm="key === 0 ? (activeInputAnalyzer ? 4: 5) : (activeInputAnalyzer ? 3: 5)"
                                                    :md="key === 0 ? (activeInputAnalyzer ? 4: 5) : (activeInputAnalyzer ? 3: 5)"
                                                >
													<v-autocomplete :rules="[rules.required]" outlined dense hide-details :items="listMeasurements" v-model="item.measurement" label="Ед.измерения" />
												</v-col>
												<v-col v-if="activeInputAnalyzer" :cols="key === 0 ? 4 : 4" :sm="key === 0 ? 4 : 4" :md="key === 0 ? 4 : 4">
													<v-autocomplete :rules="[rules.required]" outlined dense hide-details :items="listAnalyzer" label="Анализатор" />
												</v-col>
												<v-col v-if="key !== 0" cols="1" sm="1" md="1">
													<v-btn @click="deleteRow(objIndicator.propertyDataList, key)" small color="error" icon class="mt-1">
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</v-col>
											</v-row>

											<!-- Значение -->
											<v-row v-if="item.valueType == 2">
												<v-col
                                                    :cols="key === 0 ? (activeInputAnalyzer ? 8 : 12) : (activeInputAnalyzer ? 7 : 11)"
                                                    :sm="key === 0 ? (activeInputAnalyzer ? 8 : 12) : (activeInputAnalyzer ? 7 : 11)"
                                                    :md="key === 0 ? (activeInputAnalyzer ? 8 : 12) : (activeInputAnalyzer ? 7 : 11)"
                                                >
													<v-text-field :rules="[rules.required]" outlined dense hide-details v-model="item.dictionaryValue" label="Значение" />
												</v-col>
                                                <v-col v-if="activeInputAnalyzer" :cols="key === 0 ? 4 : 4" :sm="key === 0 ? 4 : 4" :md="key === 0 ? 4 : 4">
													<v-autocomplete :rules="[rules.required]" outlined dense hide-details :items="listAnalyzer" label="Анализатор" />
												</v-col>
												<v-col v-if="key !== 0" cols="1" sm="1" md="1">
													<v-btn @click="deleteRow(objIndicator.propertyDataList, key)" small color="error" icon class="mt-1">
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</v-col>
											</v-row>
											<!-- Справочник -->
											<v-row v-if="item.valueType == 3">
												<v-col :cols="key === 0 ? 12 : 11" :sm="key === 0 ? 12 : 11" :md="key === 0 ? 12 : 11">
													<v-autocomplete
														class="white-space-select"
														outlined
														multiple
														hide-details
														return-object
														item-value="dictionaryValueId"
														item-text="dictionaryValue"
														:items="listDictionaryValue"
														v-model="item.valueList"
														label="Список из справочника"
													/>
												</v-col>
												<v-col v-if="key !== 0" cols="1" sm="1" md="1">
													<v-btn @click="deleteRow(objIndicator.propertyDataList, key)" small color="error" icon class="mt-1">
														<v-icon>mdi-delete</v-icon>
													</v-btn>
												</v-col>
											</v-row>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn :loading="btnDisableIndicator" @click="!btnDisableIndicator ? closeIndicator() : ''" color="blue darken-1" dark>Отмена</v-btn>
					<v-btn :loading="btnDisableIndicator" @click="!btnDisableIndicator ? saveIndicator(objIndicator) : ''" color="success" dark>Сохранить</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Добавить/Редактировать группу -->
		<v-dialog v-model="dialogGroup" max-width="900px" persistent>
			<v-card>
				<v-toolbar dark color="#001e46">
					<v-toolbar-title style="color: rgba(129, 182, 228, 0.95)">
						{{ editeGroupFlag ? 'Редактировать' : 'Добавить' }} группу
					</v-toolbar-title>

					<v-spacer></v-spacer>

					<v-toolbar-items>
						<v-btn icon color="rgba(129, 182, 228, 0.95)" @click="closeGroup">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-card-text class="pb-0">
					<v-container>
						<v-form ref="formGroup" v-model="validGroup" lazy-validation>
							<v-row>
								<v-col cols="12" sm="12" md="12" class="mt-5">
									<v-text-field :rules="[rules.required]" outlined dense hide-details v-model="objGroup.name" label="Наименование группы" />
								</v-col>
							</v-row>
						</v-form>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn :loading="btnDisableGroup" @click="!btnDisableGroup ? closeGroup() : ''" color="blue darken-1" dark>Отмена</v-btn>
					<v-btn :loading="btnDisableGroup" @click="!btnDisableGroup ? saveGroup(objGroup, idSystems) : ''" color="success" dark>Сохранить</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar v-model="snackbar.flag" right top absolute :color="snackbar.color">
			{{ snackbar.text }}
		</v-snackbar>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import "./index.scss";

export default {
	data: () => ({
        activeInputAnalyzer: false,
        listAnalyzer: [
            'SYSMEX XN 1000',
            'MEK 9100',
            'ADVIA CENTAUR',
            'Cobas e411(601)',
            'IMMULITE 2000'
        ],
		editeOn: false,
		newIndicator: true,
		snackbar: {
			flag: false,
			text: '',
			color: ''
		},
		btnDisableGroup: false,
		btnDisableIndicator: false,
		editeIndicatorFlag: false,
		editeGroupFlag: false,
		validGroup: true,
		validIndicator: true,
		idSystems: null,
		loadTable: false,
		dialogIndicator: false,
		dialogGroup: false,
		defaultObjIndicator: {
			indicatorName: '',
			groupId: null,
			propertyGroupId: null,
			order: null,
			propertyDataList: [
				{
					ageOnMonth: null,
					valueType: null,
					isNormal: true,
					dictionaryValue: '',
					valueList: [],
					indicatorName: '',
					treeItemId: null,
					minValue: null,
					maxValue: null,
					measurement: null,
					analyzerId: null
				}
			]
		},
		objGroup: {
			name: ''
		},
		objIndicatordefaultName: '',
		objIndicator: {
			indicatorName: '',
			groupId: null,
			propertyGroupId: null,
			order: null,
			propertyDataList: [
				{
					ageOnMonth: null,
					valueType: null,
					isNormal: true,
					valueList: [],
					dictionaryValue: '',
					indicatorName: '',
					treeItemId: null,
					minValue: null,
					maxValue: null,
					measurement: null
				}
			]
		},
		headers: [
			{
				text: 'Наименование',
				align: 'start',
				value: 'groupName',
				sortable: false
			},
			{ text: 'Действия', value: 'actions', align: 'right', sortable: false }
		],
		list: [],
		listGroup: [],
		listMeasurements: [],
		listDictionaryValue: [],
		rules: {
			required: v => (!!v || v === 0) || 'Обязательно для заполнения!',
			rangeFromTo: (a, b) => {
				if(a > b) return false;
				if(a < b) return true;
				if(a === b) return true;
				return false
			}
		},
	}),
	computed: {
		...mapGetters({
			apiUrl: 'apiUrl',
			getCurrentSystemId: 'tree/getCurrentSystemId',
            curentSystem: "tree/curentSystem"
		})
	},
	watch: {
		getCurrentSystemId(val) {
            // Если Лаб исследования
            if(val === 1114) {
                this.activeInputAnalyzer = true;
            } else {
                this.activeInputAnalyzer = false;
            }

			this.getNode(val)
		},
		curentSystem(val) {
			this.activeInputAnalyzer = val.children[0].name === 'Лабораторные исследования';
		}
	},
	methods: {
		...mapActions({
			getAnalyzers: 'tree/getAnalyzers'
		}),
		addRow(array) {
			array.push({
				ageOnMonth: null,
				valueType: 1,
				isNormal: true,
				dictionaryValue: '',
				indicatorName: '',
				treeItemId: null,
				valueList: [],
				minValue: null,
				maxValue: null,
				measurement: array[array.length-1].measurement
			})
		},
		deleteRow(array, index) {
			if(confirm('Вы уверены что хотите удалить ?')) {
				array.splice(index, 1)
			}
		},

		addIndicator(groupId) {
			this.newIndicator = true;
			this.editeOn = false;
			this.objIndicator = JSON.parse(JSON.stringify(this.defaultObjIndicator));

			this.objIndicator.groupId = groupId;
			this.objIndicator.propertyGroupId = groupId;
			this.objIndicator.propertyDataList[0].valueType = 1;
			this.objIndicator.order = this.getNextIndicatorOrder(groupId);

			this.dialogIndicator = true;
		},
		closeIndicator() {
			this.$refs.form.reset()
			this.objIndicator = JSON.parse(JSON.stringify(this.defaultObjIndicator));
			this.editeIndicatorFlag = false;
			this.btnDisableIndicator = false;
			this.dialogIndicator = false;
		},
		saveIndicator(objIndicator) {
			if(this.$refs.form.validate()) {
				this.btnDisableIndicator = true;

				for (let i = 0; i < objIndicator.propertyDataList.length; i++) {
					objIndicator.propertyDataList[i].treeItemId = this.idSystems
					objIndicator.propertyDataList[i].indicatorName = objIndicator.indicatorName.trim()
					objIndicator.propertyDataList[i].propertyGroupId = objIndicator.groupId
				}

				//если сменили группу то ищем группу куда переносим и ищем там максильное число и добавляем 1
				if (objIndicator.propertyGroupId !== objIndicator.groupId) {
					objIndicator.order = this.getNextIndicatorOrder(objIndicator.groupId);
				}

				// console.log(this.editeOn, {
				// 	id: objIndicator.propertyGroupId,
				// 	indicatorName: this.editeOn ? this.objIndicatordefaultName.trim() : objIndicator.indicatorName.trim(),
				// 	order: objIndicator.order,
				// 	propertyDataList: objIndicator.propertyDataList,
				// 	propertyGroupId: objIndicator.propertyGroupId
				// });

				this.$http.post(`${this.apiUrl}BodyTree/AddIndicator?nodeid=${this.idSystems}&pgroupid=${objIndicator.propertyGroupId}`, {
					id: objIndicator.propertyGroupId,
					indicatorName: this.editeOn ? this.objIndicatordefaultName.trim() : objIndicator.indicatorName.trim(),
					order: objIndicator.order,
					propertyDataList: objIndicator.propertyDataList,
					propertyGroupId: objIndicator.propertyGroupId
				}).then(res => {
					if(res.status === 200) {
						if(!this.editeIndicatorFlag) {
							this.list.find(f => f.groupId === objIndicator.groupId).indicators.push({
								id: res.data.id,
								indicatorName: res.data.indicatorName,
								order: res.data.order,
								propertyDataList: []
							})
						} else {
							this.getNode(this.getCurrentSystemId, objIndicator.propertyGroupId);
						}
						this.closeIndicator()
					}
				})
			}
		},
		editeIndicator(obj, groupId) {
			this.editeOn = true;
			this.newIndicator = false;
			this.objIndicatordefaultName = JSON.parse(JSON.stringify(obj.indicatorName));

			this.$http.get(`${this.apiUrl}BodyTree/GetIndicatorViewMain?pgroupid=${groupId}&nodeid=${this.idSystems}&propertyName=${obj.indicatorName}`)
			.then(res => {
				this.$http.get(`${this.apiUrl}Property/GetDictionaryValueForPropertyId?propertyid=${res.data.propertyDataList.length > 0 ? res.data.propertyDataList[0].id : 0}`)
				.then(resp => {
					if(resp.status === 204) {
						this.newIndicator = true

						this.objIndicator = Object.assign({}, {groupId , ...res.data})
						this.editeIndicatorFlag = true;
						this.dialogIndicator = true;

						return;
					}

					if(resp.data.length > 0) resp.data.forEach(el => { el.dictionaryValueId = el.id, el.dictionaryValue = el.value });
					this.listDictionaryValue = resp.status === 200 ? resp.data : [];
					this.objIndicator = Object.assign({}, {groupId , ...res.data})
					this.editeIndicatorFlag = true;
					this.dialogIndicator = true;
					this.newIndicator = false;

					// console.log(this.objIndicator);
				})
			})
		},
		deleteIndicator(indicatorName, nodeid, pgroupid, array, index){
			if(confirm('Вы уверены что хотите удалить показатель?')) {
				this.$http.post(`${this.apiUrl}BodyTree/DeleteIndicator?nodeid=${nodeid}&pgroupid=${pgroupid}&indicatorName=${indicatorName}`)
				.then(res => {
					if(res.status === 200) {
						array.splice(index, 1)

						this.snackbar.flag = true;
						this.snackbar.text = 'Удаление прошло успешно!';
						this.snackbar.color = 'success';
					}
				})
				.catch(error => {
					if(error) {
						this.snackbar.flag = true;
						this.snackbar.text = 'Удаление невозможно, когда есть показатели!';
						this.snackbar.color = 'error';
					}
				})
			}
		},

		closeGroup() {
			this.$refs.formGroup.reset()
			this.objGroup = { name: '' }
			this.groupName = ''
			this.dialogGroup = false;
			this.btnDisableGroup = false;
			this.editeGroupFlag = false;
		},
		saveGroup(obj, idSystems) {
			if(this.$refs.formGroup.validate()) {
				this.btnDisableGroup = true;

				this.$http.post(`${this.apiUrl}Property/${this.editeGroupFlag ? 'UpdatePropertyGroup' : 'AddPropertyGroup'}`, {
					id: this.editeGroupFlag ? obj.id : undefined,
					name: obj.name,
					order: obj.order ? obj.order : this.getNextGroupOrder(),
					bodyTreeItemId: idSystems
				}).then(res => {
					if(!this.editeGroupFlag) {
						this.list.push({
							groupId: res.data.id,
							groupName: res.data.name,
							indicators: [],
							order: res.data.order,
							isOpen: false
						})

						this.listGroup.push(res.data)
					} else {
						for (let i = 0; i < this.list.length; i++) {
							if(this.list[i].groupId === res.data.id) {
								this.list[i].groupName = res.data.name
							}
						}
					}

					this.closeGroup()
				})
			}
		},
		editeGroup(obj) {
			this.objGroup = Object.assign({}, {id: obj.groupId, name: obj.groupName, order: obj.order, bodyTreeItemId: this.idSystems})
			this.editeGroupFlag = true;
			this.dialogGroup = true;
		},
		deleteGroup(id, index) {
			if(confirm('Вы уверены что хотите удалить группу?')) {
				this.$http.post(`${this.apiUrl}Property/DeletePropertyGroup?id=${id}`)
				.then(res => {
					if(res.status === 200) {
						this.list.splice(index, 1)

						this.snackbar.flag = true;
						this.snackbar.text = 'Удаление прошло успешно!';
						this.snackbar.color = 'success';
					}
				})
				.catch(error => {
					if(error) {
						this.snackbar.flag = true;
						this.snackbar.text = 'Удаление невозможно, когда есть показатели!';
						this.snackbar.color = 'error';
					}
				})
			}
		},

		getNode(id, groupId) {
			if(!groupId) {
				this.list = []
				this.loadTable = true
			}

			this.$http.get(`${this.apiUrl}BodyTree/GetPropertyTreeViewForMetodist?nodeid=${id}`)
			.then(res => {
				this.idSystems = res.data[0].id;

				for (let i = 0; i < res.data[0].propertyGroups.length; i++) {
					if(res.data[0].propertyGroups[i].groupId == groupId) {
						res.data[0].propertyGroups[i].isOpen = true;
					} else {
						res.data[0].propertyGroups[i].isOpen = false;
					}
				}

				this.list = res.data[0].propertyGroups.sort((a, b) => a.order - b.order);

				if(!groupId) this.loadTable = false


				this.$http.get(`${this.apiUrl}Property/GetGroupsByNode?nodeid=${res.data[0].id}`)
				.then(res => {
					this.listGroup = res.data
				})

				this.$http.get(`${this.apiUrl}Property/GetMeasurements`)
				.then(res => {
					this.listMeasurements = res.data
				})

				// this.$http.get(`${this.apiUrl}Property/GetDictionaryValueForPropertyId?propertyid=${}`)
				// .then(res => {
				// 	this.listDictionaryValue = res.data
				// })
			})
		},
		getNextGroupOrder() {
			if (this.list.length > 0) {
				return Math.max(...this.list.map(x => x.order)) + 1;
			}

			return 0;
		},
		getNextIndicatorOrder(groupId) {
			let group = this.list.find(x => x.groupId === groupId);

			if (group && group.indicators.length > 0) {
				return Math.max(...group.indicators.map(x => x.order)) + 1;
			}

			return 0;
		},
		changeIndex1level(array, indexFrom, indexTo, id, isUp) {
			array[indexFrom] = array.splice(indexTo, 1, array[indexFrom])[0];

			this.$http.post(`${this.apiUrl}Property/ChangePropertyGroupOrder?id=${id}&isUp=${isUp}`)
			.then(res => {
				if(res.status === 200) {
					// console.log('Успешно перемещено, 1 лвл');
				}
			})
		},
		changeIndex2level(nodeid, pgroupid, propertyName, array, indexFrom, indexTo, isUp) {
			array[indexFrom] = array.splice(indexTo, 1, array[indexFrom])[0];

			this.$http.post(`${this.apiUrl}BodyTree/ChangeIndicatorOrder?nodeid=${nodeid}&pgroupid=${pgroupid}&propertyName=${decodeURI(propertyName)}&isUp=${isUp}`)
			.then(res => {
				if(res.status === 200) {
					// console.log('Успешно перемещено, 2 лвл');
				}
			})
		}
	},
	mounted() {
        // Если Лаб исследования
        if(this.getCurrentSystemId === 1114) {
            this.activeInputAnalyzer = true
        }

		this.getNode(this.getCurrentSystemId);

		this.getAnalyzers();
	}
};
</script>
